module.exports = __webpack_public_path__ + "img/13手机.cf358a8e.png";